"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _themedStyles = require("./themedStyles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  font-family: ", ";\n  font-size: 1.3rem;\n  font-weight: 700;\n  min-height: ", ";\n  border-radius: 40px;\n  padding: ", ";\n  cursor: pointer;\n  outline: none;\n  letter-spacing: 0.035rem;\n  ", "\n\n  /* Makes styles consistent for HTML anchor elements and React Router Link components styled like a button */    \n  ", "\n\n  @media print, screen and (max-width: ", "px) {\n    width: 100%;\n\n    & + button,\n    & + a {\n      margin-top: 15px;\n    }\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    width: auto;\n    min-width: ", ";\n\n    & + button,\n    & + a {\n      margin-left: 15px;\n    }\n  }\n\n  /* Focus styles on on keyboard focus */\n  &[data-focus-visible-added]:focus {\n    ", "\n    /* Visible outline for high contrast mode */\n    outline: 2px solid transparent;\n  }\n\n  /* Hover styles are applied only when the user's primary input mechanism can hover over the component */\n  @media (hover: hover) { \n    &:hover:not([disabled]) {\n      ", ";\n    }\n  }\n\n\n  &:disabled,\n  *[disabled] {\n    opacity: .5;\n    cursor: not-allowed;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GuiButton = _styledComponents.default.button(_templateObject(), _themedStyles.baseStyles, _Constant.Font.PRIMARY_FONT, function (props) {
  return props.$large ? '48px' : '40px';
}, function (props) {
  return props.$large ? '14px 32px 12px' : '10px 15px 8px';
}, function (props) {
  return props.$center ? "\n        position: relative;\n        left: 50%;\n        transform: translateX(-50%);\n      " : '';
}, function (props) {
  return props.as !== 'button' ? "\n        display: inline-block;\n        text-align: center;\n        text-decoration: none;\n      " : '';
}, _Constant.Width.SM - 1, _Constant.Width.SM, function (props) {
  return props.$large ? '16.8rem' : '14rem';
}, _themedStyles.focusStyles, _themedStyles.hoverStyles);

var Button = function Button(_ref) {
  var center = _ref.center,
      descriptiveTextId = _ref.descriptiveTextId,
      large = _ref.large,
      primary = _ref.primary,
      semanticElement = _ref.semanticElement,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["center", "descriptiveTextId", "large", "primary", "semanticElement"]);
  return /*#__PURE__*/_react.default.createElement(GuiButton, (0, _extends2.default)({
    "aria-describedby": descriptiveTextId,
    variant: primary ? 'primary' : 'secondary',
    as: semanticElement,
    $center: center,
    $large: large
  }, rest));
};

Button.propTypes = {
  /** Determines if the button should be centered */
  center: _propTypes.default.bool,

  /**
   * Links legal or financial warning text to the button for assistive technology users.
   * Accepts either the id or multiple space-separated ids of the text you want to link to.
   */
  descriptiveTextId: _propTypes.default.string,

  /** Increase the minimum width of the button */
  large: _propTypes.default.bool,

  /** Function to call when the button is clicked */
  onClick: _propTypes.default.func,

  /** Sets the button to the primary colors  */
  primary: _propTypes.default.bool,

  /**
   * Keeps the button styles while rendering a different HTML element.
   * If you're not extending the Button styles, the `styled-components` `as` prop can be used directly.
   * Accepts a string representation of an HTML element or a component function
   */
  semanticElement: _propTypes.default.any
};
Button.defaultProps = {
  center: false,
  descriptiveTextId: null,
  large: false,
  onClick: null,
  primary: false,
  semanticElement: 'button'
};
var _default = Button;
exports.default = _default;